<form class="pin-form" [formGroup]="pinForm" (ngSubmit)="onSubmit()">
  <h2 appTranslationModal [translate]="'PIN_FORM.TITLE'" class="pin-form__title"></h2>
  <p appTranslationModal [translate]="'PIN_FORM.HINWEIS'" class="pin-form__hint"></p>

  <div class="form-group">
    <label for="firstPin" appTranslationModal [translate]="'PIN_FORM.ENTER_PIN_LABEL'" class="form-label"></label>
    <div class="input-group">
      <input
        #firstPinInput
        type="password"
        id="firstPin"
        formControlName="firstPin"
        class="form-control styled-input"
        appTranslationModal
        [placeholder]="'PIN_FORM.ENTER_PIN_PLACEHOLDER' | translate"
      />
      <button type="button" (click)="togglePasswordVisibility(firstPinInput)" class="eye-button">
        <span class="custom-eye" [ngClass]="firstPinInput.type === 'password' ? 'hidden' : 'visible'"></span>
      </button>
    </div>
    <div *ngIf="pinForm.get('firstPin')?.touched && pinForm.get('firstPin')?.invalid" class="error">
      <div
        *ngIf="pinForm.get('firstPin')?.errors?.['required']"
        [translate]="'PIN_FORM.PIN_REQUIRED'"
        appTranslationModal
      ></div>
      <div
        *ngIf="pinForm.get('firstPin')?.errors?.['pinRequirements']"
        [translate]="'PIN_FORM.PIN_REQUIREMENTS'"
        appTranslationModal
      ></div>
    </div>
  </div>

  <div class="form-group">
    <label for="confirmPin" appTranslationModal [translate]="'PIN_FORM.CONFIRM_PIN_LABEL'" class="form-label"></label>
    <div class="input-group">
      <input
        #confirmPinInput
        type="password"
        id="confirmPin"
        formControlName="confirmPin"
        class="form-control styled-input"
        appTranslationModal
        (paste)="onPaste($event)"
        [placeholder]="'PIN_FORM.CONFIRM_PIN_PLACEHOLDER' | translate"
      />
      <button type="button" (click)="togglePasswordVisibility(confirmPinInput)" class="eye-button">
        <span class="custom-eye" [ngClass]="confirmPinInput.type === 'password' ? 'hidden' : 'visible'"></span>
      </button>
    </div>
    <div *ngIf="pinForm.get('confirmPin')?.touched && pinForm.get('confirmPin')?.invalid" class="error">
      <div
        *ngIf="pinForm.get('confirmPin')?.errors?.['required']"
        [translate]="'PIN_FORM.CONFIRM_REQUIRED'"
        appTranslationModal
      ></div>
      <div
        *ngIf="pinForm.get('confirmPin')?.errors?.['pinRequirements']"
        [translate]="'PIN_FORM.PIN_REQUIREMENTS'"
        appTranslationModal
      ></div>
    </div>
    <div
      *ngIf="pinForm.hasError('mismatch') && pinForm.get('confirmPin')?.touched"
      [translate]="'PIN_FORM.MISMATCH_ERROR'"
      class="error"
      appTranslationModal
    ></div>
  </div>

  <button
    type="submit"
    class="submit-button"
    appTranslationModal
    [disabled]="pinForm.invalid"
    [ngClass]="{ disabled: pinForm.invalid }"
  >
    {{ 'PIN_FORM.SUBMIT' | translate }}
  </button>
</form>
